import { Form, Input} from "antd";
import './style.css';

const UIInput = (props: any) => {
    const {id, placeholder,name,value,onChange,label,defaultValue,rules,type,disabled,onBlur, onFocus, ref} = props 
  return (
      <Form.Item
        key={name}
        label={label}
        name={name}
        rules={rules}
        className= "inputBox-0"
        // initialValue={initialValue}
      >
        <Input
        id={id}
          key={name}
          placeholder={placeholder}
          name={name}
          type={type}
          disabled={disabled}
          onBlur={onBlur}
          onFocus={onFocus}
          ref={ref}
          defaultValue={defaultValue}
          value={value}
          onChange={onChange}
          className="inputBox-1"
        />
      </Form.Item>
  );
};

const UIInputPassword = (props: any) => {
  const {placeholder,name,value,onChange,label,initialValue,rules,type,disabled,onBlur} = props
return (

    <Form.Item
      label={label}
      initialValue={initialValue}
      name={name}
      rules={rules}
      className="inputBox-0"
    >
      <Input.Password 
        placeholder={placeholder}
        name={name}
        value={value}
        type={type}
        onChange={onChange}
        disabled={disabled}
        onBlur={onBlur}
        className="inputBox-1 password"
      />
    </Form.Item>
);
};
export {UIInput, UIInputPassword};

